import { Injectable } from '@angular/core';
import { SecurityInfo, SymbolType } from '../../../../../../domain/symbol.domain';
import { OrderSecurity } from '../../../../../../domain/security.domain';
import {
  MutualFundsExtendedTerms,
  OrderItem,
  InsiderType,
  MutualFundOrderAction,
  MutualFundQuantityType
} from '../../../../domain';
import { BackendMapper } from '../../../domain/services.domain';
import { CreateOrderMapper } from './create-order-mapper.service';
import type { MutualFundFormModel } from '../../../domain/order-entry.domain';

@Injectable()
export class CreateMutualfundOrderMapper extends CreateOrderMapper<MutualFundFormModel> implements BackendMapper<MutualFundFormModel> {

  getMapperType(): OrderSecurity {
    return 'mutualfund';
  }

  getItems(formModel: MutualFundFormModel): Array<OrderItem> {
    return [{
      clientInfo: {
        insiderInfo: InsiderType.NONE,
        solicited: false
      },
      quantity: 0,
      extendedTerms: this.getOrderItemExtendedTerms(formModel),
      security: this.getMutualFundOrderItemSecurity(formModel.selectedSymbol.symbol)
    }];
  }

  protected getOrderItemExtendedTerms(formModel: MutualFundFormModel): MutualFundsExtendedTerms {
    const extendedTerms = {
      dividendType: formModel.dividendOption,
      includeCommissionIndicator: formModel.includeCommissionIndicator,
      amount: formModel.quantityTypeAmount,
      units: formModel.quantityTypeUnits,
      orderAction: this.getMutualFundOrderAction(formModel.orderAction, formModel.orderQuantityType)
    } as MutualFundsExtendedTerms;

    if (formModel.orderAction === MutualFundOrderAction.SWITCH) {
      extendedTerms.switchTo = this.getMutualFundOrderItemSecurity(formModel.toSelectedSymbol.symbol);
    }

    return extendedTerms;
  }

  protected getMutualFundOrderItemSecurity(symbol: string): SecurityInfo {
    const securityInfo: SecurityInfo = {
      symbol,
      market: undefined,
      type: SymbolType.MUTUALFUND
    };
    return securityInfo;
  }

  protected getMutualFundOrderAction(orderAction: MutualFundOrderAction, quantityType: MutualFundQuantityType): MutualFundOrderAction {
    if (orderAction === MutualFundOrderAction.SELL && quantityType === MutualFundQuantityType.FULL_BALANCE) {
      return MutualFundOrderAction.SELL_ALL_MF;
    }
    if (orderAction === MutualFundOrderAction.SWITCH) {
      return quantityType === MutualFundQuantityType.FULL_BALANCE ?
        MutualFundOrderAction.FULL_MF_SWITCH : MutualFundOrderAction.PARTIAL_MF_SWITCH;
    }
    return orderAction;
  }
}

